/**
 * BOGO Bundle Sale General LP — minimal behavior
 *
 * No carousel is required for the press-logo row or the products grid (both
 * are static CSS grids/flex rows), and the FAQ uses native <details>/<summary>.
 * The only behavior this LP needs is anchor-scroll offset compensation: the
 * announcement bar + header are both `position: sticky`, so a plain in-page
 * jump to #bbsg-bundles would land partially hidden behind them.
 */
(() => {
  const initAnchorOffset = (root) => {
    const links = root.querySelectorAll('a[href^="#"]');
    if (!links.length) return;

    const getStickyOffset = () => {
      const announcement = root.querySelector('.bbsg-announcement');
      const header = root.querySelector('.bbsg-header');
      let offset = 0;
      if (announcement && getComputedStyle(announcement).position === 'sticky') {
        offset += announcement.getBoundingClientRect().height;
      }
      if (header && getComputedStyle(header).position === 'sticky') {
        offset += header.getBoundingClientRect().height;
      }
      return offset + 12;
    };

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const hash = link.getAttribute('href');
        if (!hash || hash === '#') return;

        const target = root.querySelector(hash);
        if (!target) return;

        event.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - getStickyOffset();
        window.scrollTo({ top, behavior: 'smooth' });

        if (history.pushState) {
          history.pushState(null, '', hash);
        }
      });
    });
  };

  const initAll = () => {
    document.querySelectorAll('.bbsg-lp').forEach(initAnchorOffset);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
